import { useCallback } from "react";

import { useIntl } from "react-intl";

import { currencyCodes } from "@shared/libs/fiat";

const localizedCurrency = ["RUB", "KGS", "MULTI"] as const;
type LocalizedCurrency = (typeof localizedCurrency)[number];

const isLocalizedCurrency = (value: unknown): value is LocalizedCurrency => {
  if (typeof value !== "string") {
    return false;
  }
  return (localizedCurrency as readonly string[]).includes(value);
};

export const useFormatRequisiteCurrency = () => {
  const { formatMessage } = useIntl();

  return useCallback(
    (currency: null | string) => {
      if (currency === null) {
        return formatMessage(currencyCodes.MULTI);
      }
      if (!isLocalizedCurrency(currency)) {
        return currency;
      }
      return formatMessage(currencyCodes[currency]);
    },
    [formatMessage],
  );
};
